import { CustomerSliceType } from '@/types/customer';

export enum Steps {
  businessInformation = 'businessInformation',
  companyDetails = CustomerSliceType.companyDetails,
  onlinePresence = CustomerSliceType.socialNetwork,

  businessOperations = 'businessOperations',
  companyProfile = CustomerSliceType.businessOperationsProfile,
  yourCustomers = CustomerSliceType.businessOperationsCustomers,
  sourceOfFunds = CustomerSliceType.businessOperationsFundsSource,

  organization = 'organization',
  businessContact = CustomerSliceType.organizationContact,
  legalRepresentative = CustomerSliceType.organizationLegalRepresentative,
  beneficialOwners = CustomerSliceType.organizationOwners,

  documents = 'documents',
}
